import React, {useRef, useState} from "react"
import MultiSelectionCombobox, {MultiSelectionComboboxOption} from "../MultiSelectionCombobox/MultiSelectionCombobox"
import {Countries} from "../../resources/common"
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch"
import {
	CountriesFieldWithAllowUsOnlyToggleOff,
	CountriesFieldWithAllowUsOnlyToggleType,
} from "./CountriesFieldWithAllowUsOnlyToggleUtils"

interface Props {
	name: string
	label: string
	value: CountriesFieldWithAllowUsOnlyToggleType
	setFieldValue: Function
	setFieldTouched: Function
	hideClearAllIndicator?: boolean
}

export default function CountriesFieldWithAllowUsOnlyToggle({
	name,
	label,
	value,
	setFieldValue,
	setFieldTouched,
	hideClearAllIndicator,
}: Props) {
	const entries = Object.entries(Countries)
	const [allowUsOnly, setAllowUsOnly] = useState<boolean>(value.isAllowUsOnly)
	const savedCountriesRef = useRef<string[]>(value.countries ?? [])

	const onToggleSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newToggleValue = e.target.checked
		// save the current countries value before toggling
		if (newToggleValue) {
			savedCountriesRef.current = value.countries ?? []
		}
		const countriesOfOperationValue: CountriesFieldWithAllowUsOnlyToggleType = newToggleValue
			? {
					isAllowUsOnly: true,
					countries: null,
			  }
			: {
					isAllowUsOnly: false,
					countries: savedCountriesRef.current,
			  }
		setFieldValue(name, {...value, ...countriesOfOperationValue})
		setAllowUsOnly(newToggleValue)
	}
	const multiSelectionComboboxName = `${name}.countries`
	return (
		<div className="countries-field-with-allow-us-only-toggle">
			<div className="label-text-and-toggle-container">
				<label className="label-text">{label}</label>
				<ToggleSwitch checked={value.isAllowUsOnly} onChange={onToggleSwitchChange} text="Allow U.S. only" alignRight />
			</div>
			{!allowUsOnly && (
				<MultiSelectionCombobox
					name={multiSelectionComboboxName}
					value={value.countries ?? []}
					options={entries.map(([key, val]) => ({
						value: key,
						label: val,
					}))}
					setFieldValue={(selectedOptions: MultiSelectionComboboxOption[]) => {
						const selectedCountries = selectedOptions.map((option) => option.value)
						const countriesOfOperationValue: CountriesFieldWithAllowUsOnlyToggleOff = {
							isAllowUsOnly: false,
							countries: selectedCountries,
						}
						setFieldValue(name, {...value, ...countriesOfOperationValue})
						setFieldTouched(multiSelectionComboboxName, true, false)
					}}
					hideClearAllIndicator={hideClearAllIndicator}
				/>
			)}
		</div>
	)
}
